function authConfig(OAuthProvider, OAuthTokenProvider, CONFIG) {
    'ngInject';
    OAuthProvider.configure(CONFIG.oauth);

    OAuthTokenProvider.configure({
        name: 'token',
        options: {
            secure: CONFIG.oauth.cookieSecure === 'true'
        }
    });

}

export default authConfig;



// WEBPACK FOOTER //
// ./client/app/common/auth/auth.config.js